"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Radium = require("radium");
var react_1 = require("react");
var components_1 = require("components");
var styles_1 = require("styles");
var styleComponent = {
    base: {
        display: 'flex',
        alignItems: 'center',
        height: '54px',
        borderRadius: '27px',
        borderTop: '1px solid white',
        backgroundColor: styles_1.BackgroundColor.White,
        ':focus': styles_1.elevation['2'],
    },
    input: {
        base: {
            flex: 1,
            width: '100%',
            paddingBottom: '3px',
            marginRight: '18px',
            fontWeight: 300,
            backgroundColor: styles_1.BackgroundColor.White,
            border: 'none',
        },
        noLeftElement: {
            marginLeft: '22px',
        },
    },
};
var getInputStyle = function (style, props) { return ([
    style.input.base,
    !props.leftElement && style.input.noLeftElement,
]); };
var FloatingInput = (function (_super) {
    __extends(FloatingInput, _super);
    function FloatingInput() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FloatingInput.prototype.render = function () {
        var _a = this.props, style = _a.style, leftElement = _a.leftElement, placeholder = _a.placeholder, otherProps = __rest(_a, ["style", "leftElement", "placeholder"]);
        return (React.createElement(components_1.Paper, __assign({ style: [styleComponent.base, style] }, otherProps),
            !!leftElement && leftElement,
            React.createElement("input", { style: getInputStyle(styleComponent, this.props), type: "text", placeholder: placeholder })));
    };
    FloatingInput.defaultProps = {
        placeholder: '',
        leftElement: null,
    };
    FloatingInput = __decorate([
        Radium
    ], FloatingInput);
    return FloatingInput;
}(react_1.PureComponent));
exports.FloatingInput = FloatingInput;



//////////////////
// WEBPACK FOOTER
// ./src/components/FloatingInput/FloatingInput.tsx
// module id = 301
// module chunks = 0